import { LOAD_RECENTS, ADD_RECENT } from './constants'

export const loadRecents = (topics) => ({ type: LOAD_RECENTS, topics })
export const addRecent = (topic) => ({ type: ADD_RECENT, topic })
